import { useLocale, useTranslations } from 'next-intl';
import { LocaleSwitcherSelect } from './locale-switcher-select';

type Props = {
    className?: string;
};

export const LocaleSwitcher = ({ className = '' }: Props) => {
    const t = useTranslations('LocaleSwitcher');
    const locale = useLocale();

    return <LocaleSwitcherSelect defaultValue={locale} label={t('label')} className={className} />;
};
